import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InputGroup } from 'src/app/Modules/informate/models/calculationModels';
import { IdmApiService } from 'src/app/services';

export class PipeSpecpayload {
    pipeCode: string;
    lookupParams: InputGroup;
}
@Injectable({
    providedIn: 'root',
})
export class JointCalcService {
    pipeSpecList: InputGroup[] = [];
    PipeSpecFilteredList: InputGroup[] = [];
    pipeSpecpayload: PipeSpecpayload;
    isPipeCode: boolean = false;

    isEditPipeSpec: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    ispipeSpec: EventEmitter<boolean> = new EventEmitter<boolean>(null);
    selectedLubricant: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedStandard: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPressureClass: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedpipeSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeFacingType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedgasket: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedBoltType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedboltMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedTighteningSpecification: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampManufacturer: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedclampMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPipeSchedule: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedhubMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingId: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(
        private idmApiService: IdmApiService,
        private jointCalcService: JointCalcService
    ) {}

    async FinddingPipeSpecApicall(payload): Promise<InputGroup[]> {
        const res = await this.idmApiService.findpipespecs(payload).toPromise();
        this.pipeSpecList = res.response.slice();
        this.PipeSpecFilteredList = res.response.slice();
        return this.pipeSpecList;
    }

    async managePayloadForRecourdId(key: string, FilterList, nominal?: number) {
        if (this.pipeSpecList?.length) {
            if (key != 'pipeSizeId') {
                if (key === 'flangeMaterialId' || key === 'boltMaterialId' || key === 'gasketId') {
                    const selectedPressureClassID = this.selectedPressureClass?.value;

                    if (selectedPressureClassID) {
                        this.pipeSpecList = this.pipeSpecList.filter((x) => x.recordId.pressureClassId == selectedPressureClassID);
                    }

                    let standardpipeSpec = this.pipeSpecList
                        .map((x) => {
                            if (x && x.recordId && x.recordId[key]) {
                                return {
                                    Id: x.recordId[key],
                                    AliasId:
                                        key === 'flangeMaterialId'
                                            ? x.recordId['flangeMaterialAliasId']
                                            : key === 'boltMaterialId'
                                              ? x.recordId['boltMaterialAliasId']
                                              : key === 'gasketId'
                                                ? x.recordId['gasketAliasId']
                                                : '',
                                };
                            }
                        })
                        .filter((x) => x !== undefined);

                    if (standardpipeSpec?.length) {
                        // Check if any aliasId exists
                        const hasAlias = standardpipeSpec.some((x) => x.AliasId);

                        if (hasAlias) {
                            // Deduplicate based on aliasId
                            const uniqueAliases = [...new Set(standardpipeSpec.filter((x) => x.AliasId).map((x) => x.AliasId))];

                            // Filter only on aliasId
                            FilterList = FilterList.filter((item) => uniqueAliases.includes(item?.alias?.materialAliasId));

                            const uniqueIds = [...new Set(standardpipeSpec.map((x) => x.Id))];
                            // Filter only on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            FilterList = FilterList.filter((item) => uniqueIds.includes(item[key]));
                        } else {
                            // Deduplicate based on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            const uniqueIds = [...new Set(standardpipeSpec.map((x) => x.Id))];

                            // Filter only on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            FilterList = FilterList.filter((item) => uniqueIds.includes(item[key]));
                        }
                    } else {
                        FilterList = [...FilterList];
                    }
                } else {
                    let standardpipeSpec = this.pipeSpecList.map((x) => {
                        if (x && x.recordId && x.recordId[key]) {
                            return x.recordId[key];
                        }
                    });
                    if (standardpipeSpec?.length && (standardpipeSpec[0] != undefined || standardpipeSpec[0] != null)) {
                        standardpipeSpec = [...new Set(standardpipeSpec)];
                        FilterList = FilterList.filter((item) => standardpipeSpec.includes(item[key]));
                    } else {
                        // file deepcode ignore CopyPasteError: <please specify a reason of ignoring this>, file deepcode ignore JavascriptSelfAssignment: <please specify a reason of ignoring this>
                        FilterList = [...FilterList];
                    }
                }
                return FilterList;
            } else {
                return this.PipeSpecFilteredList;
            }
        }
    }

    filterList(payload: InputGroup): any[] {
        const filters = [
            'lubricantId',
            'standardId',
            'pressureClassId',
            'flangeTypeId',
            'flangeFacingTypeId',
            'flangeMaterialId',
            'gasketId',
            'boltMaterialId',
            'manufacturerId',
            'clampMaterialId',
            'pipeScheduleId',
            'hubMaterialId',
            'sealRingMaterialId',
        ];

        const otherFilters = ['boltType', 'tighteningSpecification'];

        const list = this.pipeSpecList.filter((item) => {
            return (
                filters.every((key) => !payload?.recordId?.[key] || item.recordId[key] === payload.recordId[key]) &&
                otherFilters.every((key) => !payload?.others?.[key] || item.others[key] === payload.others[key]) &&
                (!payload.nominal || (payload.nominal >= item.minimumNominalPipeSize && payload.nominal <= item.maximumNominalPipeSize))
            );
        });

        return list;
    }
}
